"use client";
import S, { createContext as I, useContext as E, useRef as p, useState as g, useEffect as w } from "react";
import { H as R } from "../Inspector-DHMPTBrt.js";
const v = I(
  void 0
), M = () => {
  const o = E(v);
  if (o === void 0)
    throw new Error("useInspector must be used within an InspectorProvider");
  return o;
}, x = ({
  endpoint: o,
  children: c,
  styleOptions: i = {},
  overrideStudioUrl: l
}) => {
  const d = p(null), s = p(null), [f, h] = g(!1), [u, m] = g(null), a = L(() => {
    var n, t;
    const e = document.querySelectorAll(
      "[data-hygraph-entry-id]"
    );
    Array.from(e).filter(
      (y) => y && y.getBoundingClientRect().top >= 0
    ).length > 0 && !s.current ? ((n = d.current) == null || n.disconnect(), s.current = new R(o, i, l), h(!0), (t = d.current) == null || t.observe(document.body, {
      childList: !0,
      // Watch for child elements being added/removed
      subtree: !0
      // Observe the entire subtree
    })) : console.log("No visible elements found for Inspector initialization.");
  }, 300), b = () => {
    s.current = null, h(!1), a();
  };
  return w(() => {
    if (typeof window < "u") {
      m(window.location.pathname);
      const e = new MutationObserver(() => {
        a();
      });
      return e.observe(document.body, {
        childList: !0,
        subtree: !0
      }), d.current = e, a(), () => {
        e.disconnect();
      };
    }
  }, [o, a, i]), w(() => {
    if (typeof window < "u" && u !== null) {
      const e = () => {
        window.location.pathname !== u && (m(window.location.pathname), b());
      }, r = window.history.pushState, n = window.history.replaceState;
      return window.history.pushState = function(...t) {
        r.apply(window.history, t), e();
      }, window.history.replaceState = function(...t) {
        n.apply(window.history, t), e();
      }, window.addEventListener("popstate", e), () => {
        window.history.pushState = r, window.history.replaceState = n, window.removeEventListener("popstate", e);
      };
    }
  }, [u, a]), w(() => {
    if (typeof window < "u") {
      let e = !1;
      const r = {
        handleScroll: () => {
          e ? setTimeout(() => {
            e = !1;
          }, 50) : window.parent.postMessage(
            {
              action: "iframeScrollPositionChanged",
              position: { top: window.scrollY, left: window.scrollX }
            },
            "*"
          ), e = !1;
        },
        handleMessage: (t) => {
          switch (t.data.action) {
            case "scrollTo":
              t.data.position && (e = !0, window.scrollTo({
                top: t.data.position.top,
                left: t.data.position.left,
                behavior: "instant"
                // No animation
              }));
              break;
            case "parentInfo":
              s.current ? s.current.setParent(t.data.parent) : console.warn("Hygraph Inspector: no inspector instance found");
              break;
          }
        }
      }, n = () => {
        window.parent.postMessage({ action: "iframeReady" }, "*");
      };
      return window.addEventListener("scroll", r.handleScroll), window.addEventListener("message", r.handleMessage), window.addEventListener("load", n), document.readyState === "complete" && n(), () => {
        window.removeEventListener("scroll", r.handleScroll), window.removeEventListener("message", r.handleMessage), window.removeEventListener("load", n);
      };
    }
  }, [f]), /* @__PURE__ */ S.createElement(
    v.Provider,
    {
      value: { endpoint: o, isInitialized: f }
    },
    c
  );
}, L = (o, c) => {
  const i = p(null);
  return (...l) => {
    i.current && clearTimeout(i.current), i.current = window.setTimeout(() => {
      o(...l);
    }, c);
  };
};
export {
  x as HygraphInspector,
  M as useInspector
};
